import CommonMapper from '@/modules/core/mappers/CommonMapper'

import PetsHiringInsured from '@/modules/pets/hiring/models/APP/PetsHiringInsured'
import PetsSaveInsuredsRequest from '@/modules/pets/hiring/models/MID/requests/PetsSaveInsuredsRequest'

export default class SavePetsMapper {
  static toRequest(quotationId: string, pet: PetsHiringInsured): PetsSaveInsuredsRequest {
    const insuredToSave: any[] = [
      {
        ...pet,
        riskNumber: pet.riskNumber,
        petName: pet.petName ?? undefined,
        petBirthDate: pet.petBirthDate
          ? CommonMapper.toMiddlewareDate(new Date(pet.petBirthDate))
          : undefined
      }
    ]

    return new PetsSaveInsuredsRequest({
      quotationId,
      pets: insuredToSave
    })
  }
}
